import React from 'react';

export const PlayIcon = () => (
  <svg width={18} style={{ verticalAlign: 'middle' }} viewBox="0 0 14 14">
    <circle cx="7" cy="7" r="6" stroke="none" strokeWidth="2" fill="#f4f4f8" />

    <line x1="5" y1="5" x2="9" y2="7" stroke="#333" strokeWidth="1" />
    <line x1="9" y1="7" x2="5" y2="9" stroke="#333" strokeWidth="1" />
  </svg>
);
